import { Box, Tab } from '@mui/material';
import { TabContext, TabList, TabPanel } from '@mui/lab';
import { useContext, useEffect, useState } from 'react';

import { UserContext } from '../components/UserContex';
import { getAdmin } from '../services/Account';
import ExportToCSV from './admin/ExportToCSV';
import AdministerAdmins from './admin/AdministerAdmins';

const Admin = () => {
  const [tab, setTab] = useState('1');
  const [isAdmin, setIsAdmin] = useState(false);

  const user = useContext(UserContext);

  useEffect(() => {
    if (user) {
      getAdmin(user?.uid).then((response) => {
        if (response?.uid === user?.uid) {
          setIsAdmin(true);
        }
      });
    }
  }, [user]);

  return (
    <>
      {isAdmin ? (
        <TabContext value={tab}>
          <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
            <TabList onChange={(event, index) => setTab(index)} aria-label="Admin tabs">
              <Tab label="Eksporter CSV" value="1" />
              <Tab label="Administer admins" value="2" />
            </TabList>
          </Box>
          <TabPanel value="1" children={<ExportToCSV />} />
          <TabPanel value="2" children={<AdministerAdmins />} />
        </TabContext>
      ) : (
        <span>Du har ikke rettigheter til å se dette innholdet.. 😭</span>
      )}
    </>
  );
};

export default Admin;
